import { Col, Form, Modal, Row, Spin, Tooltip, type FormInstance } from "antd";
import React, { use, useEffect, useState } from "react";
import Text from "../../../components/Text/Text";
import color from "../../../resource/color";
import Button from "../../../components/Button/Button";
import { CloseOutlined, DownOutlined, PlusOutlined, ScanOutlined } from "@ant-design/icons";
import Input from "../../../components/Input/Input";
import { FlexCol, FlexRow } from "../../../components/Container/Container";
import Collapse from "../../../components/Collapse/collapse";
import image from "../../../resource/image";
import { AddProductContainer } from "../StyleProductQuota";
import { getQuotaWording } from "../../../utility/formatterQuota";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import ModalSelectProduct from "../QuotaComponents/ModalSelectProduct";
import {
  QuotaCollapseHeaderDup,
  ShopDetailCollapseDup,
  QuotaGroupCollapseHeaderDup,
  QuotaGroupProductHeaderDup,
  QuotaGroupShopDetailCollapseDup,
} from "../QuotaComponentsDup/QuotaCollapseDup";
import RenderSpecialContentDup from "../QuotaComponentsDup/RenderSpecialContentDup";
import { ModalSelectStore } from "../QuotaComponents/ModalSelectStore";
import { SettingConditionQuotaEachShopProduct } from "../QuotaComponentsDup/ModalSettingQuotaCondition";
import { numberFormatter } from "../../../utility/Formatter";
import { handleNumberOnlyCopyPaste } from "../../../utility/validator";
import Radio from "../../../components/Radio/Radio";
import styled from "styled-components";

const EditQuotaModal = styled(Modal)`
  .ant-modal-content {
    padding: 0 !important;
  }
`;

interface StepTwoDupProps {
  form1: FormInstance;
  form2: FormInstance;
  shopGroupData: any;
  isEditing?: boolean;
  zoneList: any[];
  errorMessage?: { success: boolean; step: number; message: string } | null;
  setErrorMessage?: any;
  loadingStep?: boolean;
  setLoadingStep?: any;
}

export const StepTwoDup = ({
  form1,
  form2,
  shopGroupData,
  isEditing,
  zoneList,
  errorMessage,
  setErrorMessage,
  loadingStep,
  setLoadingStep,
}: StepTwoDupProps) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const form1Values = form1.getFieldsValue(true);
  const form2Values = form2.getFieldValue("products") || [];
  const _watchForm2 = Form.useWatch("products", form2);
  const instructionText = getQuotaWording(form1Values.quotaType, "instruction");
  const [modalSelectProduct, setModalSelectProduct] = useState<boolean>(false);
  const [modalSelectStore, setModalSelectStore] = useState<boolean>(false);
  const [modalSettingCondition, setModalSettingCondition] = useState(false);

  const deleteProduct = (productId: number) => {
    const setDeleteProduct =
      form2.getFieldValue("products")?.filter((product: any) => product.productId === productId) ||
      [];
    form2.setFieldValue("deleteProductsInGroup", [
      ...(form2.getFieldValue("deleteProductsInGroup") || []),
      setDeleteProduct[0],
    ]);

    const _resetProduct = form2;
    setDeleteProduct?.map((item: any) => {
      form2.setFieldValue(`specialPrice-${item.productId}`, undefined);
      form2.setFieldValue(`limitQty-${item.productId}`, undefined);
      item.storeList?.map((s: any) => {
        const keyForm = `${item.productId}-${s?.customerCompanyId}`;
        form2.setFieldValue(`quotaReceive-${keyForm}`, undefined);
        form2.setFieldValue(`orderPerDay-${keyForm}`, undefined);
      });
    });

    const updatedProducts = form2
      .getFieldValue("products")
      ?.filter((product: any) => product.productId !== productId);
    form2.setFieldsValue({ products: updatedProducts });
  };
  const checkProductSelected = () => {
    const productList = form2.getFieldValue("products") || [];
    const productSelectedList: any = [];
    if (form1Values.quotaType === "QUOTA_GROUP") {
      productList.forEach((product: any) => {
        product.productList.forEach((prod) => {
          productSelectedList.push(prod);
        });
      });
    } else {
      productList.forEach((product: any) => {
        productSelectedList.push(product);
      });
    }
    return productSelectedList;
  };

  useEffect(() => {
    setTimeout(() => {
      setLoadingStep(false);
    }, 300);
  }, [loadingStep]);

  return (
    <>
      {loadingStep ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <Form form={form2}>
          <Row align='top'>
            <Col span={16} style={{ marginBottom: 10 }}>
              <Text level={5} fontWeight={700}>
                {getQuotaWording(form1Values.quotaType, "label")}{" "}
                <span style={{ color: color.error }}>*</span>
              </Text>
            </Col>
            <Col span={8}>
              <Row justify='end' gutter={24}>
                {form2.getFieldValue("products")?.length > 0 && (
                  <>
                    {(form1Values.limitQuantityOrder ||
                      form1Values.quotaShopPrice === "SPECIAL_PRICE") && (
                      <Col
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          title='เพิ่มเงื่อนไขเดียวกัน'
                          icon={<ScanOutlined />}
                          style={{ width: "max-content" }}
                          typeButton='border-primary'
                          onClick={() => setModalSettingCondition(true)}
                        />
                      </Col>
                    )}
                    <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Tooltip
                        title={
                          form1Values.quotaType === "QUOTA_GROUP" ? "สร้างได้มากสุด 10 รายการ" : ""
                        }
                      >
                        <Button
                          title={getQuotaWording(form1Values.quotaType, "addProduct") ?? "-"}
                          icon={<PlusOutlined style={{ color: color.white }} />}
                          style={{ width: "max-content" }}
                          typeButton={"primary"}
                          onClick={() =>
                            form1Values.quotaType === "QUOTA_TOTAL"
                              ? setModalSelectProduct(true)
                              : setModalSelectStore(true)
                          }
                        />
                      </Tooltip>
                    </Col>
                  </>
                )}
              </Row>
            </Col>
          </Row>
          {errorMessage?.success && errorMessage?.step === 1 && (
            <Text level={5} color='error'>
              {errorMessage?.message}
            </Text>
          )}
          <br />
          {!form2.getFieldValue("products")?.length ? (
            <AddProductContainer
              onClick={() =>
                form1Values.quotaType === "QUOTA_TOTAL"
                  ? setModalSelectProduct(true)
                  : setModalSelectStore(true)
              }
            >
              <FlexCol style={{ width: "100%" }} align='center'>
                <img src={image.addProduct} style={{ width: 70, height: 80, marginBottom: 12 }} />
                <Text level={3} color='primary'>
                  {getQuotaWording(form1Values.quotaType, "addProduct")}
                </Text>
                <Text level={5} style={{ textAlign: "center" }}>
                  {instructionText.split("\n").map((line, idx) => (
                    <span key={idx}>
                      {line}
                      <br />
                    </span>
                  ))}
                </Text>
              </FlexCol>
            </AddProductContainer>
          ) : (
            <>
              {form1Values.quotaType === "QUOTA_TOTAL" && (
                <RenderQuotaTotal
                  form1={form1}
                  form2={form2}
                  handleDeleteProduct={(id) => deleteProduct(id)}
                />
              )}
              {form1Values.quotaType === "QUOTA_INDIVIDUAL" && (
                <RenderQuotaIndividual
                  form1={form1}
                  form2={form2}
                  shopGroupData={shopGroupData}
                  handleDeleteProduct={(id) => deleteProduct(id)}
                  zoneList={zoneList || []}
                  isEditing={isEditing}
                />
              )}
              {form1Values.quotaType === "QUOTA_GROUP" && (
                <RenderQuotaGroup
                  form1={form1}
                  form2={form2}
                  shopGroupData={shopGroupData}
                  isEditing={isEditing}
                  zoneList={zoneList || []}
                />
              )}
            </>
          )}
        </Form>
      )}

      {modalSelectProduct && (
        <Modal open={modalSelectProduct} width={1350} closable={false} footer={null}>
          <ModalSelectProduct
            list={checkProductSelected() || form2.getFieldValue("products") || []}
            setList={(products) => {
              setLoadingStep(true);
              let mapProductList: any = products.map((item) => {
                return {
                  productId: item.productId,
                  productImage: item.productImage,
                  productName: item.productName,
                  saleUOM: item.saleUOM,
                  saleUOMTH: item.saleUOMTH,
                  company: item.company,
                  commonName: item.commonName,
                  productBrandId: item.productBrandId,
                  productBrandName: item.productBrandName,
                  productStatus: item.productStatus,
                  marketPrice: item.marketPrice,
                  discount: null,
                  orderLimit: null,
                  productQuotaId: undefined,
                  productQuotaGroupId: undefined,
                  quotaUse: 0,
                  packSize: item.packSize,
                  productCodeNAV: item.productCodeNAV,
                };
              });
              if (form1Values.quotaType === "QUOTA_INDIVIDUAL") {
                mapProductList = mapProductList.map((item: any) => {
                  return {
                    ...item,
                    storeList: form2.getFieldValue("stores") || [],
                  };
                });
                form2.setFieldsValue({
                  products: form2.getFieldValue("products")
                    ? [...form2.getFieldValue("products"), ...mapProductList]
                    : mapProductList,
                });
              } else if (form1Values.quotaType === "QUOTA_GROUP") {
                const mapGroup = {
                  groupNo: form2Values?.length + 1,
                  productList: mapProductList,
                  storeList: form2.getFieldValue("stores") || [],
                };
                form2.setFieldsValue({
                  products: form2.getFieldValue("products")
                    ? [...form2.getFieldValue("products"), mapGroup]
                    : [mapGroup],
                });
              } else if (form1Values.quotaType === "QUOTA_TOTAL") {
                form2.setFieldsValue({
                  products: form2.getFieldValue("products")
                    ? [...form2.getFieldValue("products"), ...mapProductList]
                    : mapProductList,
                });
              }
              setErrorMessage(null);
              setModalSelectProduct(false);
              setTimeout(() => {
                if (form1Values.quotaType !== "QUOTA_TOTAL") {
                  form2.setFieldValue("stores", undefined);
                }
                setLoadingStep(false);
              }, 500);
            }}
            withBackButton={{
              title: form1Values.quotaType === "QUOTA_TOTAL" ? "ยกเลิก" : "ย้อนกลับ",
              onBack: () => {
                setModalSelectProduct(false);
                if (form1Values.quotaType !== "QUOTA_TOTAL") {
                  setModalSelectStore(true);
                }
              },
            }}
            customTitle={
              <Text level={4} fontWeight={700}>
                เพิ่มสินค้า
              </Text>
            }
          />
        </Modal>
      )}
      {modalSelectStore && (
        <ModalSelectStore
          showModalShop
          excludeCusCompanyId={[]}
          callBackShop={(stores) => {
            setLoadingStep(true);
            form2.setFieldsValue({
              stores: stores.map((store) => ({
                ...store,
                isChecked: false,
                quotaReceive: null,
                quotaUsed: null,
              })),
            });
            setErrorMessage(null);
            setModalSelectStore(false);
            setModalSelectProduct(true);
            setTimeout(() => {
              setLoadingStep(false);
            }, 300);
          }}
          currentSelectShop={form2.getFieldValue("stores") || []}
          company={userCompany.companyCode}
          onClose={() => {
            setModalSelectStore(false);
            setModalSelectProduct(false);
          }}
          customerType='DL'
          replaceSaveButtonTitle='ถัดไป'
          replaceTitle={
            <FlexCol>
              <Text level={4} fontWeight={700}>
                เพิ่มร้านค้าและสินค้า
              </Text>
              <br />
              <FlexRow align='end'>
                <Text fontWeight={700}>ขั้นตอน 1/2 : เลือกร้านค้า</Text>&nbsp;
                <Text color='Text3' level={6}>
                  เลือกได้มากกว่า 1 ร้านค้า
                </Text>
              </FlexRow>
            </FlexCol>
          }
          hideCurrect
          isFilterShop={false}
        />
      )}
      {modalSettingCondition && (
        <SettingConditionQuotaEachShopProduct
          open={modalSettingCondition}
          onClose={() => setModalSettingCondition(false)}
          isSpecialPrice={form1Values.quotaShopPrice === "SPECIAL_PRICE"}
          isLimitOrder={form1Values.limitQuantityOrder}
          onSubmit={(s, l, conditionType) => {
            setLoadingStep(true);
            const mapProduct = form2.getFieldValue("products") || [];
            if (form1Values.quotaType !== "QUOTA_GROUP") {
              mapProduct.map((product: any) => {
                if (conditionType.includes("specialPrice")) {
                  form2.setFieldValue(`specialPrice-${product.productId}`, s);
                }
                if (conditionType.includes("limitOrder")) {
                  form2.setFieldValue(`limitQty-${product.productId}`, l);
                }
              });
            } else {
              mapProduct.map((group: any) => {
                group?.productList?.map((product: any) => {
                  if (conditionType.includes("specialPrice")) {
                    form2.setFieldValue(`specialPrice-${product.productId}`, s);
                  }
                  if (conditionType.includes("limitOrder")) {
                    form2.setFieldValue(`limitQty-${product.productId}`, l);
                  }
                });
              });
            }
            setModalSettingCondition(false);
            setTimeout(() => {
              setLoadingStep(false);
            }, 300);
          }}
        />
      )}
    </>
  );
};
export const RenderQuotaTotal = ({
  form1,
  form2,
  handleDeleteProduct,
  isDetail,
}: {
  form1: any;
  form2: any;
  handleDeleteProduct?: (productId: number) => void;
  isDetail?: boolean;
}) => {
  const form1Values = form1.getFieldsValue(true);
  const form2Values = form2.getFieldValue("products") || [];
  const _watchForm2 = Form.useWatch([], form2);
  const [modalConfirmDeleteTotal, setModalConfirmDeleteTotal] = useState<any>({
    open: false,
    productId: null,
    productName: null,
  });
  const [dataProductSearch, setDataProductSearch] = useState(form2Values || []);
  const [searchProductName, setSearchProductName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (searchProductName) {
      setDataProductSearch(
        form2Values.filter((product: any) => product.productName.includes(searchProductName)),
      );
    } else {
      setDataProductSearch(form2Values);
    }
    setLoading(false);
  }, [searchProductName, form2Values]);

  return (
    <>
      <Row justify={"space-between"} gutter={8}>
        <Col span={7}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อสินค้า'
            onPressEnter={(e: any) => {
              if (!e.target.value) {
                setSearchProductName("");
              } else {
                setSearchProductName(e.target.value);
              }
            }}
          />
        </Col>
        {loading ? (
          <Col>
            <Spin size='small' />
          </Col>
        ) : (
          <Col>
            <Text>จำนวน {dataProductSearch?.length} รายการ</Text>
          </Col>
        )}
      </Row>
      <br />
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <Form form={form2}>
          <div style={{ overflowX: "auto", maxHeight: 800 }}>
            {dataProductSearch?.map((product, index) => {
              return (
                <Form.Item noStyle key={product.productId}>
                  <Collapse
                    style={{ marginBottom: 20 }}
                    key={product.productId}
                    paddingContentSpecial={!form1Values.isSpecialPrice ? "0px" : "none"}
                    backgroundColor={"#EBF0F5"}
                  >
                    <Collapse.Panel
                      showArrow={false}
                      header={
                        <QuotaCollapseHeaderDup
                          key={product.productId}
                          product={product}
                          onDeleteProd={() =>
                            setModalConfirmDeleteTotal({
                              open: true,
                              productId: product.productId,
                              productName: product.productName,
                            })
                          }
                          customStyle={{ padding: "20px" }}
                          isDetail={isDetail}
                        >
                          <RenderSpecialContentDup
                            isSpecial={form1Values.quotaShopPrice === "SPECIAL_PRICE"}
                            isLimitedOrder={form1Values.limitQuantityOrder}
                            marketPrice={product.marketPrice}
                            saleUOMTH={product.saleUOMTH}
                            keyNameLimitQty={`limitQty-${product.productId}`}
                            keyNameSpecialPrice={`specialPrice-${product.productId}`}
                            isDetail={isDetail}
                            form2={form2}
                          />
                        </QuotaCollapseHeaderDup>
                      }
                      key={product.productId}
                    />
                  </Collapse>
                </Form.Item>
              );
            })}
          </div>
        </Form>
      )}
      {modalConfirmDeleteTotal.open && (
        <ConfirmModal
          visible={modalConfirmDeleteTotal.open}
          onConfirm={() => {
            handleDeleteProduct?.(modalConfirmDeleteTotal.productId);
            setModalConfirmDeleteTotal({
              open: false,
              productId: null,
              productName: null,
            });
          }}
          onCancel={() => {
            setModalConfirmDeleteTotal({
              open: false,
              productId: null,
              productName: null,
            });
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={"ยืนยันการลบสินค้า"}
          desc={`คุณต้องการลบสินค้า ${modalConfirmDeleteTotal.productName} หรือไม่?`}
        />
      )}
    </>
  );
};
export const RenderQuotaIndividual = ({
  form1,
  form2,
  shopGroupData,
  zoneList,
  handleDeleteProduct,
  isDetail,
  isEditing,
}: {
  form1: any;
  form2: any;
  shopGroupData: any;
  zoneList: any[];
  handleDeleteProduct?: (productId: number) => void;
  isDetail?: boolean;
  isEditing?: boolean;
}) => {
  const form1Values = form1.getFieldsValue(true);
  const form2Values = form2.getFieldValue("products") || [];
  const _watchForm2 = Form.useWatch("products", form2);
  const [modalConfirmDeleteIndividual, setModalConfirmDeleteIndividual] = useState<any>({
    open: false,
    productId: null,
    productName: null,
  });
  const productList = form2Values;
  const [dataProductSearch, setDataProductSearch] = useState(form2Values || []);
  const [searchProductName, setSearchProductName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchProductName) {
      setDataProductSearch(
        productList.filter((product: any) => product.productName.includes(searchProductName)),
      );
    } else {
      setDataProductSearch(productList);
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [searchProductName, form2Values]);

  return (
    <>
      <Row justify={"space-between"} gutter={8}>
        <Col span={7}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อสินค้า'
            onPressEnter={(e: any) => {
              if (!e.target.value) {
                setSearchProductName("");
              } else {
                setSearchProductName(e.target.value);
                setLoading(true);
              }
            }}
          />
        </Col>
        {loading ? (
          <Col>
            <Spin size='small' />
          </Col>
        ) : (
          <Col>
            <Text>จำนวน {dataProductSearch?.length} รายการ</Text>
          </Col>
        )}
      </Row>
      <br />
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40vh",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <>
          {dataProductSearch.map((product, index) => {
            return (
              <Form.Item noStyle key={index}>
                <Collapse
                  style={{ marginBottom: 20 }}
                  key={product.productId}
                  iconPadding={"30px 10px"}
                  backgroundColor={"#E5EAEE"}
                  defaultActiveKey={product.productId}
                  collapsible='icon'
                  expandIconPosition='end'
                  expandIcon={({ isActive }) => (
                    <DownOutlined
                      style={{
                        color: color.Text1,
                        fontSize: 16,
                      }}
                      rotate={isActive ? 180 : 0}
                    />
                  )}
                >
                  <Collapse.Panel
                    header={
                      <QuotaCollapseHeaderDup
                        key={product.productId}
                        product={product}
                        onDeleteProd={() =>
                          setModalConfirmDeleteIndividual({
                            open: true,
                            productId: product.productId,
                            productName: product.productName,
                          })
                        }
                        customStyle={{ padding: "20px" }}
                        isDetail={isDetail}
                      />
                    }
                    key={product.productId}
                  >
                    <Form form={form2}>
                      <RenderSpecialContentDup
                        isSpecial={form1Values.quotaShopPrice === "SPECIAL_PRICE"}
                        isLimitedOrder={form1Values.limitQuantityOrder}
                        marketPrice={product.marketPrice}
                        saleUOMTH={product.saleUomTh || product.saleUOMTH}
                        keyNameLimitQty={`limitQty-${product.productId}`}
                        keyNameSpecialPrice={`specialPrice-${product.productId}`}
                        isDetail={isDetail}
                        form2={form2}
                      />

                      <br />
                      <ShopDetailCollapseDup
                        form1={form1}
                        form2={form2}
                        zoneList={zoneList || []}
                        shopGroupData={shopGroupData}
                        dataProduct={product}
                        index={index}
                        isDetail={isDetail}
                        isEditing={isEditing}
                        productId={product.productId}
                      />
                    </Form>
                  </Collapse.Panel>
                </Collapse>
              </Form.Item>
            );
          })}
        </>
      )}
      {modalConfirmDeleteIndividual.open && (
        <ConfirmModal
          visible={modalConfirmDeleteIndividual.open}
          onConfirm={() => {
            handleDeleteProduct?.(modalConfirmDeleteIndividual?.productId);
            setModalConfirmDeleteIndividual({
              open: false,
              productId: null,
              productName: null,
            });
          }}
          onCancel={() => {
            setModalConfirmDeleteIndividual({
              open: false,
              productId: null,
              productName: null,
            });
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={"ยืนยันการลบสินค้า"}
          desc={`คุณต้องการลบสินค้า ${modalConfirmDeleteIndividual.productName} หรือไม่?`}
        />
      )}
    </>
  );
};
export const RenderQuotaGroup = ({
  form1,
  form2,
  shopGroupData,
  zoneList,
  isDetail,
  isEditing,
}: {
  form1: any;
  form2: any;
  shopGroupData: any;
  zoneList: any[];
  isDetail?: boolean;
  isEditing?: boolean;
}) => {
  const form1Values = form1?.getFieldsValue(true);
  const form2Values = form2?.getFieldValue("products") || [];
  const _watchForm2 = Form.useWatch("products", form2);
  const [modalConfirmDeleteGroup, setModalConfirmDeleteGroup] = useState<any>({
    open: false,
    groupNo: null,
  });
  const [modalConfirmDeleteProdInGroup, setModalConfirmDeleteProdInGroup] = useState<any>({
    open: false,
    productId: null,
    productName: null,
    groupNo: null,
  });
  const [dataProductSearch, setDataProductSearch] = useState(
    form2?.getFieldValue("products") || [],
  );
  const [searchProductName, setSearchProductName] = useState<string | undefined>(undefined);
  const [productSelected, setProductSelected] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let filteredData = [];
    if (searchProductName) {
      filteredData = form2Values?.filter((product: any) => {
        return product?.productList?.some((prod: any) =>
          prod?.productName?.includes(searchProductName),
        );
      });
    } else {
      filteredData = form2Values;
    }
    setDataProductSearch(filteredData);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [searchProductName, form2Values, _watchForm2]);

  useEffect(() => {
    const proSelected: any = [];
    (form2Values || [])?.forEach((group: any) => {
      proSelected.push(...(group?.productList || []));
    });
    setProductSelected(proSelected);
  }, [form2Values]);

  const deleteProductInQuotaGroup = (productId: number, groupNo: number) => {
    const dataList = form2
      .getFieldValue("products")
      .find((group: any) => group?.groupNo === groupNo);

    const setDeleteProduct = dataList?.productList?.find(
      (prod: any) => prod.productId === productId,
    );
    form2.setFieldValue("deleteProductsInGroup", [
      ...(form2.getFieldValue("deleteProductsInGroup") || []),
      setDeleteProduct,
    ]);

    const _resetProduct = dataList?.productList
      ?.filter((product: any) => product.productId === productId)
      ?.map((item: any) => {
        form2.setFieldValue(`specialPrice-${item.productId}`, undefined);
        form2.setFieldValue(`limitQty-${item.productId}`, undefined);
      });

    const updatedProducts = dataList?.productList?.filter(
      (prod: any) => prod.productId !== productId,
    );

    form2.setFieldValue(["products", groupNo - 1, "productList"], updatedProducts);
  };
  const deleteQuotaGroup = (groupNo: number) => {
    const dataList = form2.getFieldValue("products") || [];
    const setDeleteGroup = dataList.find((group: any) => group.groupNo === groupNo);
    form2.setFieldValue("deleteGroups", [
      ...(form2.getFieldValue("deleteGroups") || []),
      setDeleteGroup,
    ]);

    const _resetProduct = dataList
      ?.find((group: any) => group?.groupNo === groupNo)
      ?.productList?.map((item: any) => {
        form2.setFieldValue(`specialPrice-${item.productId}`, undefined);
        form2.setFieldValue(`limitQty-${item.productId}`, undefined);
      });

    const _resetShop = dataList
      ?.find((group: any) => group?.groupNo === groupNo)
      ?.storeList?.map((s: any) => {
        const keyForm = `${s.customerCompanyId}-${groupNo}`;
        form2.setFieldValue(`quotaReceive-${keyForm}`, undefined);
        form2.setFieldValue(`orderPerDay-${keyForm}`, undefined);
      });

    form2.setFieldValue(`productQuotaGroupId-${dataList.length}`, undefined);
    const updatedProducts = dataList.filter((group: any) => group?.groupNo !== groupNo);

    const reorderGroup = updatedProducts.map((group: any, index: number) => {
      form2.setFieldValue(
        `productQuotaGroupId-${index + 1}`,
        group?.productList[0]?.productQuotaGroupId,
      );
      const _reorderProductList = group?.productList.map((prod: any) => {
        form2.setFieldValue(`specialPrice-${prod.productId}`, Number(prod.discount));
        form2.setFieldValue(`limitQty-${prod.productId}`, Number(prod.orderLimit));
        return prod;
      });
      const _reorderShopList = group?.storeList.map((s: any) => {
        const keyForm = `${s.customerCompanyId}-${index + 1}`;
        form2.setFieldValue(`quotaReceive-${keyForm}`, s.quotaReceive);
        form2.setFieldValue(`orderPerDay-${keyForm}`, s.orderPerDay);
        return s;
      });
      return {
        ...group,
        groupNo: index + 1,
      };
    });

    form2.setFieldsValue({ products: reorderGroup });
  };

  return (
    <>
      <Row justify={"space-between"} gutter={8}>
        <Col span={7}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อสินค้า'
            onPressEnter={(e: any) => {
              if (!e.target.value) {
                setSearchProductName("");
              } else {
                setSearchProductName(e.target.value);
                setLoading(true);
              }
            }}
          />
        </Col>
        {loading ? (
          <Col>
            <Spin size='small' />
          </Col>
        ) : (
          <Col>
            <Text>จำนวน {dataProductSearch?.length} กลุ่ม</Text>
          </Col>
        )}
      </Row>
      <br />
      <Form form={form2} layout='vertical'>
        {loading ? (
          <Col>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
              }}
            >
              <Spin size='large' />
            </div>
          </Col>
        ) : (
          <>
            {dataProductSearch?.map((product: any, index: number) => {
              return (
                <Form.Item noStyle key={product?.groupNo}>
                  <Collapse
                    key={product?.groupNo}
                    style={{ marginBottom: 20 }}
                    iconPadding={"0px 10px 0px 10px"}
                    backgroundColor={color.softSecondary}
                    defaultActiveKey={product?.groupNo}
                    collapsible='icon'
                    expandIconPosition='end'
                    expandIcon={({ isActive }) => (
                      <DownOutlined
                        style={{ color: color.white, fontSize: 16 }}
                        rotate={isActive ? 180 : 0}
                      />
                    )}
                  >
                    <Collapse.Panel
                      header={
                        <QuotaGroupCollapseHeaderDup
                          key={product?.groupNo}
                          form1={form1}
                          form2={form2}
                          groupIndex={index}
                          onDeleteGroup={() => {
                            setModalConfirmDeleteGroup({ open: true, groupNo: product?.groupNo });
                          }}
                          isDetail={isDetail}
                          groupNo={product?.groupNo}
                          productSelected={productSelected}
                        />
                      }
                      key={product?.groupNo}
                    >
                      <>
                        <div
                          style={{
                            maxHeight: 500,
                            overflowY: "auto",
                            margin: "-16px",
                            marginBottom: "20px",
                          }}
                          key={product?.groupNo}
                        >
                          {product?.productList?.map((prod: any, idx: number) => {
                            return (
                              <>
                                <Form.Item name={"products"} noStyle>
                                  <QuotaGroupProductHeaderDup
                                    key={prod.productId}
                                    form2={form2}
                                    product={prod}
                                    onDeleteProd={() =>
                                      setModalConfirmDeleteProdInGroup({
                                        open: true,
                                        productId: prod.productId,
                                        productName: prod.productName,
                                        groupNo: product?.groupNo,
                                      })
                                    }
                                    customStyle={{
                                      backgroundColor: "#EBF0F5",
                                      padding: "16px",
                                      borderTop: idx === 0 ? "none" : `1px solid ${color.Disable}`,
                                    }}
                                    isCondition={{
                                      isShowCondition:
                                        form1Values.quotaShopPrice === "SPECIAL_PRICE" ||
                                        form1Values.limitQuantityOrder,
                                      isSpecialPrice:
                                        form1Values.quotaShopPrice === "SPECIAL_PRICE",
                                      isLimitOrder: form1Values.limitQuantityOrder,
                                    }}
                                    isDetail={isDetail}
                                  />
                                </Form.Item>
                              </>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            position: "sticky",
                            background: "#fff",
                            zIndex: 10,
                          }}
                        >
                          <QuotaGroupShopDetailCollapseDup
                            key={product?.groupNo}
                            form1={form1}
                            form2={form2}
                            shopGroupData={shopGroupData}
                            dataProduct={product?.productList}
                            isDetail={isDetail}
                            groupIndex={index}
                            isEditing={isEditing}
                            zoneList={zoneList}
                            groupNo={product?.groupNo}
                            shopList={product?.storeList}
                            searchProduct={searchProductName}
                          />
                        </div>
                      </>
                    </Collapse.Panel>
                  </Collapse>
                </Form.Item>
              );
            })}
          </>
        )}
      </Form>
      {modalConfirmDeleteProdInGroup && (
        <ConfirmModal
          visible={modalConfirmDeleteProdInGroup?.open}
          onConfirm={() => {
            deleteProductInQuotaGroup(
              modalConfirmDeleteProdInGroup?.productId,
              modalConfirmDeleteProdInGroup?.groupNo,
            );
            setModalConfirmDeleteProdInGroup({
              open: false,
              productId: null,
              groupNo: null,
              productName: null,
            });
          }}
          onCancel={() => {
            setModalConfirmDeleteProdInGroup({
              open: false,
              productId: null,
              groupNo: null,
              productName: null,
            });
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={"ยืนยันการลบสินค้า"}
          desc={`คุณต้องการลบสินค้า ${modalConfirmDeleteProdInGroup.productName} หรือไม่?`}
        />
      )}
      {modalConfirmDeleteGroup.open && (
        <ConfirmModal
          visible={modalConfirmDeleteGroup?.open}
          onConfirm={() => {
            deleteQuotaGroup(modalConfirmDeleteGroup?.groupNo);
            setModalConfirmDeleteGroup({ open: false, groupNo: null });
          }}
          onCancel={() => {
            setModalConfirmDeleteGroup({ open: false, groupNo: null });
          }}
          typeButtonSubmit='danger'
          typeButtonCancel='border-danger'
          title={"ยืนยันการลบกลุ่มสินค้า"}
          desc={`คุณต้องการลบกลุ่มสินค้าที่ ${modalConfirmDeleteGroup?.groupNo} หรือไม่?`}
        />
      )}
    </>
  );
};
export const ModalAdjustQuota = ({
  open,
  setOpen,
  cusData,
  keyNameAdjust,
  keyNameReceive,
  onSubmit,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  cusData?: any;
  keyNameAdjust?: string;
  keyNameReceive?: string;
  onSubmit?: (value: any, keyNameAdjust?: string, keyNameReceive?: string) => void;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const saleUnit = userCompany.companyCode === "ICPL" ? "ลัง" : "ตัน";
  const [formAdjust] = Form.useForm();

  return (
    <>
      <EditQuotaModal open={open} width={440} closable={false} footer={null} centered>
        <Row align='top' justify='space-between' style={{ padding: "20px 24px 12px" }}>
          <Text level={3} fontWeight={700}>
            เพิ่ม/ลดโควตารายร้าน
          </Text>
          <CloseOutlined onClick={() => setOpen(false)} />
        </Row>
        <FlexCol style={{ padding: "16px 24px", backgroundColor: "#F3F6F9" }}>
          <Text>
            <span style={{ fontWeight: 700 }}>ชื่อร้านค้า:&nbsp;</span>
            {cusData?.customerName || "-"}
          </Text>
          <Text>
            <span style={{ fontWeight: 700 }}>โควตาถูกใช้ / ทั้งหมด:&nbsp;</span>
            {numberFormatter(cusData?.quotaUsed || 0, 2)}&nbsp;/&nbsp;
            {numberFormatter(cusData?.quotaReceive || 0, 2)}&nbsp;
            {saleUnit}
          </Text>
        </FlexCol>
        <div style={{ padding: "16px 24px", borderBottom: "1px solid #E5EAEE" }}>
          <Form form={formAdjust} layout='vertical' requiredMark={false}>
            <Form.Item
              name='adjustType'
              label='เลือกรูปแบบโควตา'
              rules={[{ required: true, message: "โปรดเลือกรูปแบบโควตา" }]}
            >
              <Radio
                items={[
                  {
                    key: "1",
                    value: 1,
                    label: "เพิ่มโควตา",
                  },
                  {
                    key: "-1",
                    value: -1,
                    label: "ลดโควตา",
                  },
                ]}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              />
            </Form.Item>
            <Form.Item
              name='adjustValue'
              dependencies={["adjustType"]}
              label='จำนวนโควตา'
              rules={[
                {
                  required: true,
                  message: "โปรดระบุจำนวนโควตา",
                },
                {
                  message: "กรุณาลดโควตาให้ไม่เกินจำนวนที่เหลืออยู่",
                  validator(rule, value, callback) {
                    const { adjustType, adjustValue } = formAdjust.getFieldsValue();
                    let nextValue = 0;
                    if (adjustType < 0) {
                      nextValue =
                        parseFloat(cusData?.quotaReceive) -
                        (parseFloat(cusData?.quotaUsed) + parseFloat(adjustValue));
                    } else {
                      nextValue = parseFloat(cusData?.quotaReceive) + parseFloat(adjustValue);
                    }
                    if (nextValue < 0)
                      return Promise.reject(new Error("กรุณาลดโควตาให้ไม่เกินจำนวนที่เหลืออยู่"));
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                placeholder='ระบุจำนวนโควตา'
                suffix={saleUnit}
                onKeyDown={handleNumberOnlyCopyPaste}
                autoComplete='off'
              />
            </Form.Item>
          </Form>
        </div>
        <Row justify='end' gutter={12} style={{ padding: "16px 24px 8px" }}>
          <Col span={6}>
            <Button title='ยกเลิก' typeButton='primary-light' onClick={() => setOpen(false)} />
          </Col>
          <Col span={6}>
            <Button
              title='บันทึก'
              typeButton='primary'
              onClick={async () => {
                try {
                  await formAdjust.validateFields().then((values) => {
                    onSubmit?.(values, keyNameAdjust, keyNameReceive);
                    setOpen(false);
                  });
                } catch (error) {
                  console.log(error);
                }
              }}
            />
          </Col>
        </Row>
      </EditQuotaModal>
    </>
  );
};
